import { useFormContext } from 'react-hook-form';

import type { CompetitorFormSchema } from '../schemas';

export const useCompetitorFormContext = () => useFormContext<CompetitorFormSchema>();
